import * as React from 'react';
import { memo } from 'react';
const SvgShopNext = (props) => (
  <svg width={21} height={16} viewBox="0 0 21 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M20.5821 8.70711C20.9726 8.31658 20.9726 7.68342 20.5821 7.29289L14.2181 0.928932C13.8276 0.538408 13.1945 0.538408 12.8039 0.928932C12.4134 1.31946 12.4134 1.95262 12.8039 2.34315L18.4608 8L12.8039 13.6569C12.4134 14.0474 12.4134 14.6805 12.8039 15.0711C13.1945 15.4616 13.8276 15.4616 14.2181 15.0711L20.5821 8.70711ZM0.1875 9H19.875V7H0.1875V9Z" />
  </svg>
);
const Memo = memo(SvgShopNext);
export default Memo;
